export default __webpack_public_path__ + "static/media/page-decoration-9.56b01149.svg";